import { CSSProperties } from 'react'

const Container = ({
  classSection = '',
  classChildContainer = '',
  children,
  styleSection = {}
}: {
  classSection?: string
  classChildContainer?: string
  children: any
  styleSection?: CSSProperties
}) => {
  return (
    <section
      className={`w-full flex justify-center px-6 ${classSection}`}
      style={styleSection}
    >
      <div className={`w-full xl:w-[1280px] ${classChildContainer}`}>
        {children}
      </div>
    </section>
  )
}

export default Container
